// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"grid-view"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M10 3H3V10H10V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M14 3H21V10H14V3Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 14H14V21H21V14Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M10 14H3V21H10V14Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10 3H3V10H10V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M14 3H21V10H14V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21 14H14V21H21V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10 14H3V21H10V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const GridViewIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'grid-view',
    ref,
    icon: element,
  },
));

GridViewIcon.displayName = 'GridViewIcon';

export default GridViewIcon;
